import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sf-card__line" }
const _hoisted_2 = { class: "sf-card__name" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "sf-card__leader",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "sf-card__prices" }
const _hoisted_5 = { class: "sf-card__price sf-card__price--old" }
const _hoisted_6 = { class: "sf-card__price sf-card__price--promo" }
const _hoisted_7 = {
  key: 1,
  class: "sf-card__price"
}
const _hoisted_8 = {
  key: 0,
  class: "sf-card__desc only-2-lines"
}
const _hoisted_9 = {
  key: 1,
  class: "sf-card__badge sf-card__badge--inline"
}
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    fill: "currentColor"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "sf-card__media"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 0,
  class: "sf-card__badge"
}
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    fill: "currentColor"
  })
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "sf-card__body" }
const _hoisted_20 = { class: "sf-card__name" }
const _hoisted_21 = {
  key: 0,
  class: "sf-card__desc only-2-lines"
}
const _hoisted_22 = {
  key: 1,
  class: "sf-card__badge sf-card__badge--inline"
}
const _hoisted_23 = { class: "sf-card__prices" }
const _hoisted_24 = { class: "sf-card__price sf-card__price--old" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "sf-card__price-label" }, "De: ", -1)
const _hoisted_26 = { class: "sf-card__price sf-card__price--promo" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "sf-card__price-label" }, "Por: ", -1)
const _hoisted_28 = {
  key: 1,
  class: "sf-card__price"
}
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    fill: "currentColor"
  })
], -1)
const _hoisted_31 = [
  _hoisted_30
]

import { computed } from 'vue'
import { getProductImage } from '@/global/state/GlobalState'
import { storefrontTemplate, storefrontShowImages, storefrontShowDescription, storefrontImageShape, storefrontShowAddButton, ProductCardVariant } from '@/global/state/StorefrontState'
import { formatBRL, hasPromotion } from './storefrontUtils'

/* global defineProps, defineEmits, withDefaults */

export default /*#__PURE__*/_defineComponent({
  __name: 'StoreProductCard',
  props: {
    product: {},
    variant: { default: undefined },
    thumb: { type: Boolean, default: true }
  },
  emits: ['select'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const cardVariant = computed<ProductCardVariant>(() => props.variant ?? storefrontTemplate.value)
const imageVisible = computed(() => cardVariant.value !== 'minimal' && storefrontShowImages.value)
const imageShape = storefrontImageShape
/** "+" opens the same product modal as the card (products may have required add-ons). */
const addButtonVisible = computed(() => storefrontShowAddButton.value)
const descriptionVisible = computed(() => storefrontShowDescription.value && !!props.product?.description)
const promo = computed(() => hasPromotion(props.product))
const percentBadge = computed(() => props.product?.discountType == 'percent' && !!props.product?.discount)

function select() {
  emit('select', props.product)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sf-card cursor-pointer", [`sf-card--${cardVariant.value}`, `sf-card--shape-${_unref(imageShape)}`, { 'sf-card--no-image': !imageVisible.value, 'sf-card--has-add': addButtonVisible.value && !imageVisible.value }]]),
    role: "button",
    tabindex: "0",
    onClick: select,
    onKeydown: _withKeys(select, ["enter"])
  }, [
    (cardVariant.value === 'minimal')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, [
              (promo.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatBRL)(_ctx.product.price)), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatBRL)(_ctx.product.promotionalPrice)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(formatBRL)(_ctx.product.price)), 1))
            ])
          ]),
          (descriptionVisible.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.product.description), 1))
            : _createCommentVNode("", true),
          (percentBadge.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.product.discount) + "% off", 1))
            : _createCommentVNode("", true),
          (addButtonVisible.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "sf-card__add",
                "aria-label": `Adicionar ${_ctx.product.name}`,
                onClick: _withModifiers(select, ["stop"]),
                onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
              }, _hoisted_12, 40, _hoisted_10))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (imageVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _unref(getProductImage)(_ctx.product, _ctx.thumb),
                  alt: _ctx.product.name,
                  loading: "lazy",
                  onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                }, null, 40, _hoisted_14),
                (percentBadge.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.product.discount) + "% off", 1))
                  : _createCommentVNode("", true),
                (addButtonVisible.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "sf-card__add sf-card__add--on-media",
                      "aria-label": `Adicionar ${_ctx.product.name}`,
                      onClick: _withModifiers(select, ["stop"]),
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                    }, _hoisted_18, 40, _hoisted_16))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.product.name), 1),
            (descriptionVisible.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.product.description), 1))
              : _createCommentVNode("", true),
            (percentBadge.value && !imageVisible.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.product.discount) + "% off", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              (promo.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("s", null, _toDisplayString(_unref(formatBRL)(_ctx.product.price)), 1)
                    ]),
                    _createElementVNode("span", _hoisted_26, [
                      _hoisted_27,
                      _createTextVNode(_toDisplayString(_unref(formatBRL)(_ctx.product.promotionalPrice)), 1)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(formatBRL)(_ctx.product.price)), 1))
            ])
          ]),
          (addButtonVisible.value && !imageVisible.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "sf-card__add",
                "aria-label": `Adicionar ${_ctx.product.name}`,
                onClick: _withModifiers(select, ["stop"]),
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
              }, _hoisted_31, 40, _hoisted_29))
            : _createCommentVNode("", true)
        ], 64))
  ], 34))
}
}

})